export default __webpack_public_path__ + "static/tad_vip_2-acbcf296c5a2bc0196b8f5f7e8b2f02f.jpg";